// src/components/sidebar/useAdminUnreadMessages.js (adjust the folder if needed)
// Total number of unread client messages, for the "Messages" icon badge (ADMIN only).
import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

export default function useAdminUnreadMessages(intervalMs = 15000) {
  const [unreadMessages, setUnreadMessages] = useState(0);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) return;
    try {
      const { data } = await axios.get(
        `${API_URL}/messages/admin/unread-summary`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setUnreadMessages(data.total || 0);
    } catch (err) {
      /* silent: we'll retry on the next poll */
    }
  }, []);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, intervalMs);
    return () => clearInterval(id);
  }, [refresh, intervalMs]);

  return [unreadMessages, setUnreadMessages, refresh];
}